import React, { useState, useEffect } from 'react';
import { Box, FormLabel, GridItem, Button, Center } from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLocationDot } from '@fortawesome/pro-solid-svg-icons';
import AddressAutocomplete from '@/app/components/getDelAddress/page';
import { useSelector } from 'react-redux';
import './summary.css';
import SlotPending from '@/app/components/pageComponets/gym/SlotPending';

export default function DeliveryAddress({ addressType }) {
  const showDelError = useSelector((state) => state.site.DelAddError);
  const [isSlotPendingModalOpen, setIsSlotPendingModalOpen] = useState(false);

  const survey = useSelector((state) => state.gym.survey);
  const serviceOpt = useSelector((state) => state.gym.serviceOpt);
  const bookingCheck = useSelector((state) => state.gym.bookingCheck);
  const paidSurvey = survey.some(
    (item) => item.type === 'paid' && item.selected === true
  );

  const capitalizedAddressType =
    addressType.charAt(0).toUpperCase() + addressType.slice(1);
  useEffect(() => {
    console.log('showDelError ', showDelError);
    console.log('paidSurvey ', paidSurvey);
    showDelError && serviceOpt !== 'basic'
      ? setIsSlotPendingModalOpen(true)
      : setIsSlotPendingModalOpen(false);
  }, [showDelError, paidSurvey]);
  useEffect(() => {
    setIsSlotPendingModalOpen(false);
  }, []);
  return (
    <>
      <GridItem>
        <Box width="100%">
          <FormLabel className="formLabel">
            <FontAwesomeIcon
              className="formIcon"
              icon={faLocationDot}
              width="20px"
              color="#00000090"
            />
            {capitalizedAddressType} Address
          </FormLabel>
        </Box>
        <AddressAutocomplete addressType={addressType} />
        <Box
          className="errorStyle"
          paddingLeft="2vw"
          width="100%"
          height="100%"
          fontSize={{ base: '3vw', md: '0.7vw' }}
          marginTop={{ base: '2vw', md: '0' }}
        >
          {!showDelError && (
            <Box padding={{ base: '0', md: '1vw 0' }}>
              Delivery Address is Required
            </Box>
          )}
        </Box>
      </GridItem>

      <SlotPending
        isOpen={isSlotPendingModalOpen}
        onClose={() => setIsSlotPendingModalOpen(false)}
      ></SlotPending>
    </>
  );
}
